import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.min.js';
import DOMHelper from "../../lib/dom-helper";
import { EasingFunctions } from "../../lib/animation-module";
import {DEFER_INIT_EVENTS} from "../../global/constants";

export default class YoutubeVideo {
	constructor($root, $timeline = null) {
		this.$root = $root;
		this.$timeline = $timeline;
		this.$player = null;

		this.videoId = null;
		this.youTubePlayer = null;

		this.init();
	}

	init() {
		this.$player = this.$root.querySelector('.post-constructor-youtube_player');
		this.videoId = this.$player.dataset && this.$player.dataset.videoId ? this.$player.dataset.videoId : null;

		if (this.videoId) {
			this.bootstrap();
		}
	}

	bootstrap() {
		/* Run module on any user action */
		const events = DEFER_INIT_EVENTS;
		const handler = e => {
			e.stopPropagation();

			this.loadYouTubePlayer();
			this.createPlayer();

			events.forEach(event => {
				window.removeEventListener(event, handler);
			});
		};

		events.forEach(event => {
			window.addEventListener(event, handler);
		});
	}

	loadYouTubePlayer() {
		if (document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
			return;
		}

		const firstScriptTag = document.getElementsByTagName('script')[0];
		const tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	createPlayer() {
		window.youtubeApiCallbacks.push(() => {
			this.youTubePlayer = new YT.Player(this.$player.id, {
				height: '100%',
				width: '100%',
				videoId: this.videoId,
				events: {
					onReady: () => {
						if (this.$timeline) {
							this.initTimeline();
						}
					}
				}
			});
		});
	}

	initTimeline() {
		const $chapters = this.$timeline.querySelectorAll('[data-time]');

		if (!$chapters.length) {
			return;
		}

		const smoothScroll = new SmoothScroll();

		$chapters.forEach(($chapter) => {
			$chapter.addEventListener('click', () => {
				const timeStr = $chapter.dataset.time;
				const chunks = timeStr.split(':');
				let seconds = null;

				// Parse time string to number value of seconds
				if (chunks.length === 3) {
					seconds = +chunks[0] * 3600 + +chunks[1] * 60 + +chunks[2];
				} else if (chunks.length === 2) {
					seconds = +chunks[0] * 60 + +chunks[1];
				}

				if (seconds != null) {
					this.youTubePlayer.seekTo(seconds, true);
				}

				// Scroll to player
				const margin = window.matchMedia('(max-width: 600px)').matches ? 78 : 72;
				const scrollToPos = DOMHelper.getElementTopPosition(this.$root) - margin;

				// Prevent bug when scrolling gets stuck on repeating scroll trigger
				// if window is on element's position
				// but window scrollY pos value is float number
				if (scrollToPos === Math.floor(window.scrollY) || scrollToPos === Math.ceil(window.scrollY)) {
					return;
				}

				smoothScroll.animateScroll(scrollToPos, null, {
					speed: 360,
					customEasing: EasingFunctions.primary
				});
			});
		});
	}
}